function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.82857 8.02857C9.05714 8.25714 9.05714 8.6 8.82857 8.82857C8.71429 8.94286 8.6 9 8.42857 9C8.25714 9 8.14286 8.94286 8.02857 8.82857L5 5.8L1.97143 8.82857C1.85714 8.94286 1.74286 9 1.57143 9C1.4 9 1.28571 8.94286 1.17143 8.82857C0.942857 8.6 0.942857 8.25714 1.17143 8.02857L4.2 5L1.17143 1.97143C0.942857 1.74286 0.942857 1.4 1.17143 1.17143C1.4 0.942857 1.74286 0.942857 1.97143 1.17143L5 4.2L8.02857 1.17143C8.25714 0.942857 8.6 0.942857 8.82857 1.17143C9.05714 1.4 9.05714 1.74286 8.82857 1.97143L5.8 5L8.82857 8.02857Z",
  fill: "#BF3939",
  stroke: "#BF3939"
});

var SvgXIcon = function SvgXIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x-icon.8acb4a1d.svg";
export { ForwardRef as ReactComponent };